// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Y87I","footer":"ModalCreateQualiphyProcedure_footer__3gPMu","additionData":"ModalCreateQualiphyProcedure_additionData__2KPeV"};